"use client";
import styled from "../../../client-utils/styled/index.js";
import { TRIPLE, SEPTENDECUPLE } from "../../../constants/numbers.consts.js";
import PopupMenu from "../../../components/molecules/PopupMenu/index.js";
import CardMenuAtom from "../../../components/atoms/CardMenu/index.js";
import Box from "../../../components/atoms/Box/index.js";
import SkeletonAtom from "../../../components/atoms/Skeleton/index.js";
const coreComponentName = "SdbNotificationMenu";
export const Root = styled(PopupMenu, {
    name: coreComponentName,
    slot: "Root",
})();
export const Header = styled(Box, { name: coreComponentName, slot: "Header" })(({ theme }) => ({
    minHeight: theme.spacing(SEPTENDECUPLE),
}));
export const HeaderInner = styled(Box, { name: coreComponentName, slot: "HeaderInner" })(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: theme.spacing(TRIPLE),
}));
export const Main = styled(Box, { name: coreComponentName, slot: "Main" })();
export const CardMenu = styled(CardMenuAtom, {
    name: coreComponentName,
    slot: "CardMenu",
})({
    paddingTop: 0,
    paddingBottom: 0,
});
export const Skeleton = styled(SkeletonAtom, {
    name: coreComponentName,
    slot: "Skeleton",
})({
    height: 28,
    width: "70%",
    marginBottom: 4,
});
export const SkeletonCardMenu = styled(SkeletonAtom, {
    name: coreComponentName,
    slot: "SkeletonCardMenu",
})({
    height: 40,
});
